import { Outlet } from "react-router-dom"
const SubRouteOutlet = () => {
  return (
    <Outlet />
  )
}
export default SubRouteOutlet